// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"37914f20","419":"b68cdec5"}[chunkId] + ".chunk.js";
};